var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarGreenBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1289 1.49918L13.1687 7.77688C13.3755 8.41328 13.9685 8.84416 14.6377 8.84416L21.2384 8.84416L15.8983 12.724C15.3569 13.1173 15.1304 13.8145 15.3372 14.4509L17.3769 20.7286L12.0368 16.8487C11.4955 16.4554 10.7624 16.4554 10.221 16.8487L4.88092 20.7286L6.92067 14.4509C7.12745 13.8145 6.90092 13.1173 6.35957 12.724L1.01944 8.84416L7.6202 8.84416C8.28935 8.84416 8.8824 8.41328 9.08918 7.77688L11.1289 1.49918Z",
    stroke: "#47FFBD",
    strokeWidth: 1.54458
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGreenBorder);
export default __webpack_public_path__ + "static/media/star-green-border.ba11318fd26f14f3b1cbeaa3834d52f8.svg";
export { ForwardRef as ReactComponent };